import React ,{useEffect,useState} from 'react';
import { getTextByType, EsimTextFieldName } from '../idfEsimTextHelper';


function EsimStrip(props) {
    const [text, setText] = useState();

    useEffect(() => {
          let stripText = getTextByType(EsimTextFieldName.Strip);
          setText(stripText);

    }, [props.processType]);

  return (
    <div className='esim-strip'>
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 3.98a1.528 1.528 0 1 1-1.527 1.528A1.535 1.535 0 0 1 12 6.98zm1.6 9.66a.437.437 0 0 0 .437-.438l-.008-.853a.437.437 0 0 0-.437-.437h-.437v-3.63a.438.438 0 0 0-.438-.437h-2.316a.437.437 0 0 0-.438.438v.86c0 .242.196.438.438.438h.437v2.323h-.437a.437.437 0 0 0-.438.438v.86c0 .242.196.438.438.438h3.198z'
          fill='#000'
        />
      </svg>
      <span>{text}</span>
    </div>
  );
}

export default EsimStrip;
